<template>
  <el-dialog
    :close-on-click-modal="false"
    title="修改票据信息"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
        labelWidth="140px"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  invoiceDetail,
  invoiceEdit,
} from 'api/getPay';
import {
  getFileUrl,
} from 'api';
import {
  getAddressOptions,
} from '@qx/utils';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '抬头(企业名称)',
            value: 'billLookUp',
            type: 'input',
            placeholder: '请输入抬头(企业名称)',
            disabled: true,
          },
          {
            label: '税号',
            value: 'taxpayerNumber',
            type: 'input',
            placeholder: '请输入税号',
          },
          {
            label: '负责人',
            value: 'linkMan',
            type: 'input',
            placeholder: '请输入负责人',
          },
          {
            label: '注册电话',
            value: 'linkPhone',
            type: 'input',
            placeholder: '请输入注册电话',
          },
          {
            label: '注册住所详细地址',
            value: 'companyAddress',
            type: 'input',
            placeholder: '请输入注册住所详细地址',
          },
          {
            label: '开户银行',
            value: 'bankName',
            type: 'input',
            placeholder: '请输入开户银行',
          },
          {
            label: '银行账户',
            value: 'acctNo',
            type: 'input',
            placeholder: '请输入银行账户',
          },
          {
            label: '收件人',
            value: 'consignee',
            type: 'input',
            placeholder: '请输入收件人',
          },
          {
            label: '收件电话',
            value: 'consigneePhone',
            type: 'input',
            placeholder: '请输入收件电话',
          },
          {
            label: '邮寄地址',
            value: 'addressChoose',
            type: 'cascader',
            default: [],
            options: getAddressOptions({
              showLevel: 1,
            }),
            placeholder: '请输入邮寄地址',
          },
          {
            label: '邮寄详细地址',
            value: 'address',
            type: 'input',
            placeholder: '请输入邮寄详细地址',
          },
          {
            label: '营业执照',
            value: 'businessLicense',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '企业资质',
            value: 'operationCertificate',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '托运协议',
            value: 'paymentAgreement',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
          {
            label: '默认主体',
            value: 'defaultFlag',
            type: 'radio',
            default: false,
            options: [
              {
                label: '是',
                value: true,
              },
              {
                label: '否',
                value: false,
              },
            ],
          },
        ],
        rules: { // 表单验证规则
          billLookUp: [ // 抬头
            { required: true, message: '请输入抬头', trigger: 'blur' },
          ],
          taxpayerNumber: [ // 税号
            { required: true, message: '请输入税号', trigger: 'blur' },
          ],
          linkMan: [ // 负责人
            { required: true, message: '请输入负责人', trigger: 'blur' },
          ],
          linkPhone: [ // 注册电话
            { required: true, message: '请输入注册电话', trigger: 'blur' },
          ],
          companyAddress: [ // 注册住所详细地址
            { required: true, message: '请输入注册住所详细地址', trigger: 'blur' },
          ],
          bankName: [ // 开户银行
            { required: true, message: '请输入开户银行', trigger: 'blur' },
          ],
          acctNo: [ // 银行账户
            { required: true, message: '请输入银行账户', trigger: 'blur' },
          ],
          consignee: [ // 收件人
            { required: true, message: '请输入收件人', trigger: 'blur' },
          ],
          consigneePhone: [ // 收件电话
            { required: true, message: '请输入收件电话', trigger: 'blur' },
          ],
          addressChoose: [ // 邮寄地址
            { required: true, message: '请选择邮寄地址', trigger: 'blur' },
          ],
          address: [ // 邮寄详细地址
            { required: true, message: '请输入邮寄详细地址', trigger: 'blur' },
          ],
          businessLicense: [ // 营业执照
            { required: true, message: '请选择营业执照', trigger: 'blur' },
          ],
          operationCertificate: [ // 企业资质
            { required: true, message: '请选择企业资质', trigger: 'blur' },
          ],
          paymentAgreement: [ // 托运协议
            { required: true, message: '请选择托运协议', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(async () => {
        this.$refs.customForm.reset();
        this.getDetailLoading = true;
        const res = await invoiceDetail({
          relSeq: item.relSeq,
        });
        this.originData = res;
        const billInfo = res.receiveRel.billInfo;
        const billReceive = res.receiveRel.billReceive;
        const formData = {
          billLookUp: item.acctName, // 抬头
          // taxpayerNumber: item.taxpayerNumber, // 税号
          // billLookUp: billInfo.billLookUp, // 抬头
          taxpayerNumber: billInfo.taxpayerNumber, // 税号
          linkMan: billInfo.linkMan, // 负责人
          linkPhone: billInfo.linkPhone, // 注册电话
          companyAddress: billInfo.companyAddress, // 注册住所详细地址
          bankName: billInfo.bankName, // 开户银行
          acctNo: billInfo.acctNo, // 银行账户
          consignee: billReceive.consignee, // 收件人
          consigneePhone: billReceive.consigneePhone, // 收件电话
          addressChoose: [ // 邮寄地址
            billReceive.provinceId,
            billReceive.cityId,
            billReceive.districtId,
          ],
          address: billReceive.address, // 邮寄详细地址
          defaultFlag: res.defaultFlag, // 默认主体
        };
        if (billInfo.businessLicense) { // 营业执照
          const urlRes = await getFileUrl({
            flowIds: billInfo.businessLicense,
            _GRID_TYPE: 'jq',
          });
          formData.businessLicense = [{
            id: billInfo.businessLicense,
            url: urlRes.rows[0].fullPath,
          }];
        } else {
          formData.businessLicense = [];
        }
        if (billInfo.operationCertificate) { // 企业资质
          const urlRes = await getFileUrl({
            flowIds: billInfo.operationCertificate,
            _GRID_TYPE: 'jq',
          });
          formData.operationCertificate = [{
            id: billInfo.operationCertificate,
            url: urlRes.rows[0].fullPath,
          }];
        } else {
          formData.operationCertificate = [];
        }
        if (billInfo.billAgreement && billInfo.billAgreement.agreement) { // 托运协议
          const urlRes = await getFileUrl({
            flowIds: billInfo.billAgreement.agreement,
            _GRID_TYPE: 'jq',
          });
          formData.paymentAgreement = [{
            id: billInfo.billAgreement.agreement,
            url: urlRes.rows[0].fullPath,
          }];
        } else {
          formData.paymentAgreement = [];
        }
        this.$refs.customForm.setVal(formData);
        this.getDetailLoading = false;
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      // 邮寄地址
      form.provinceId = form.addressChoose[0];
      form.cityId = form.addressChoose[1];
      form.districtId = form.addressChoose[2];
      form.businessLicense = form.businessLicense[0].id;
      form.operationCertificate = form.operationCertificate[0].id;
      form.agreement = form.paymentAgreement[0].id;
      this.setFormVal(this.originData.receiveRel.billInfo.billAgreement, form, true);
      this.setFormVal(this.originData.receiveRel.billInfo, form, true);
      this.setFormVal(this.originData.receiveRel.billReceive, form, true);
      const res = await invoiceEdit({
        billAccountTenantRelString: JSON.stringify(this.originData),
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
